module.exports = __webpack_public_path__ + "img/gsgc2901_1.d1eca02e.svg";